export default function () {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="20" viewBox="0 0 17 20" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.3565 3.4096C10.9169 3.4096 8.95786 1.62604 8.94192 1.61092L8.5 1.18555L8.05354 1.61092C8.03531 1.63036 6.11732 3.4096 1.64124 3.4096C1.47267 3.4096 1.29955 3.40744 1.12415 3.40097L0.500009 3.38153L0.5 11.546C0.5 13.6621 1.30638 16.7499 8.28132 19.1121L8.5 19.1855L8.71868 19.1121C15.6936 16.7499 16.5 13.6621 16.5 11.546L16.5 3.38153L15.8736 3.40097C15.6982 3.40744 15.5251 3.4096 15.3565 3.4096Z"
                stroke="url(#paint0_linear_567_4182)"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle cx="8.5" cy="10.1855" r="4.5" stroke="url(#paint1_linear_567_4182)" />
            <path d="M8.5 8.18555V10.6855" stroke="#DBAB6A" strokeLinecap="round" />
            <path d="M8.5 10.6855L10.5 10.6855" stroke="#DBAB6A" strokeLinecap="round" />
            <defs>
                <linearGradient id="paint0_linear_567_4182" x1="16" y1="2.59834" x2="6.8515" y2="18.6251" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FBD997" />
                    <stop offset="1" stopColor="#C99352" />
                </linearGradient>
                <linearGradient id="paint1_linear_567_4182" x1="8.5" y1="5.18555" x2="8.5" y2="15.1855" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F5D08E" />
                    <stop offset="1" stopColor="#CE9958" />
                </linearGradient>
            </defs>
        </svg>
    );
}
